'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from 'react';
const makeSelection = node => ({
  id: node.id,
  handle: node.handle
});
const useFilePermissions = (tree, groupHandle, fileTypeHandles) => {
  const $ = _c(65);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      id: "",
      handle: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [selectedGroup, setSelectedGroup] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      id: "",
      handle: ""
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedType, setSelectedType] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      id: "",
      handle: ""
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [selectedScheme, setSelectedScheme] = useState(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      id: "",
      handle: ""
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [selectedOrientation, setSelectedOrientation] = useState(t3);
  let t4;
  let t5;
  if ($[4] !== groupHandle || $[5] !== selectedGroup || $[6] !== tree) {
    t4 = () => {
      if (tree.length > 0 && !selectedGroup.handle) {
        const root = tree.find(t6 => {
          const {
            handle
          } = t6;
          return handle === groupHandle;
        });
        if (root) {
          setSelectedGroup(makeSelection(root));
        }
      }
    };
    t5 = [tree, selectedGroup, groupHandle, setSelectedGroup];
    $[4] = groupHandle;
    $[5] = selectedGroup;
    $[6] = tree;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  bb0: {
    let t7;
    if ($[9] !== fileTypeHandles || $[10] !== selectedGroup || $[11] !== tree) {
      let t8;
      if ($[14] !== selectedGroup) {
        t8 = leaf => leaf.handle === selectedGroup.handle;
        $[14] = selectedGroup;
        $[15] = t8;
      } else {
        t8 = $[15];
      }
      const group = tree.find(t8);
      if (!group) {
        let t9;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
          t9 = [];
          $[16] = t9;
        } else {
          t9 = $[16];
        }
        t6 = t9;
        break bb0;
      }
      let t9;
      if ($[17] !== fileTypeHandles) {
        t9 = t10 => {
          const {
            handle: handle_0
          } = t10;
          if (fileTypeHandles.length === 0) {
            return true;
          }
          const i = fileTypeHandles.findIndex(typeHandle => typeHandle === handle_0);
          return i > -1;
        };
        $[17] = fileTypeHandles;
        $[18] = t9;
      } else {
        t9 = $[18];
      }
      t7 = group.children.map(makeSelection).filter(t9);
      $[9] = fileTypeHandles;
      $[10] = selectedGroup;
      $[11] = tree;
      $[12] = t7;
      $[13] = t6;
    } else {
      t7 = $[12];
      t6 = $[13];
    }
    t6 = t7;
  }
  const displayTypes = t6;
  let t7;
  let t8;
  if ($[19] !== displayTypes || $[20] !== selectedType) {
    t7 = () => {
      if (displayTypes.length > 0) {
        if (!selectedType.handle) {
          setSelectedType(displayTypes[0]);
        } else {
          const valid = displayTypes.find(t9 => {
            const {
              id
            } = t9;
            return id === selectedType.id;
          });
          if (!valid) {
            setSelectedType(displayTypes[0]);
          }
        }
      }
    };
    t8 = [displayTypes, selectedType];
    $[19] = displayTypes;
    $[20] = selectedType;
    $[21] = t7;
    $[22] = t8;
  } else {
    t7 = $[21];
    t8 = $[22];
  }
  useEffect(t7, t8);
  let t9;
  bb1: {
    let t10;
    if ($[23] !== selectedGroup || $[24] !== selectedType || $[25] !== tree) {
      let t11;
      if ($[28] !== selectedGroup) {
        t11 = leaf_0 => leaf_0.handle === selectedGroup.handle;
        $[28] = selectedGroup;
        $[29] = t11;
      } else {
        t11 = $[29];
      }
      const group_0 = tree.find(t11);
      if (!group_0) {
        let t12;
        if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
          t12 = [];
          $[30] = t12;
        } else {
          t12 = $[30];
        }
        t9 = t12;
        break bb1;
      }
      let t12;
      if ($[31] !== selectedType) {
        t12 = leaf_1 => leaf_1.handle === selectedType.handle;
        $[31] = selectedType;
        $[32] = t12;
      } else {
        t12 = $[32];
      }
      const type = group_0.children.find(t12);
      if (!type) {
        let t13;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
          t13 = [];
          $[33] = t13;
        } else {
          t13 = $[33];
        }
        t9 = t13;
        break bb1;
      }
      t10 = type.children.map(makeSelection);
      $[23] = selectedGroup;
      $[24] = selectedType;
      $[25] = tree;
      $[26] = t10;
      $[27] = t9;
    } else {
      t10 = $[26];
      t9 = $[27];
    }
    t9 = t10;
  }
  const displayOrientations = t9;
  let t10;
  let t11;
  if ($[34] !== displayOrientations || $[35] !== selectedOrientation) {
    t10 = () => {
      if (displayOrientations.length > 0) {
        if (!selectedOrientation.handle) {
          setSelectedOrientation(displayOrientations[0]);
        } else {
          const valid_0 = displayOrientations.find(t12 => {
            const {
              id: id_0
            } = t12;
            return id_0 === selectedOrientation.id;
          });
          if (!valid_0) {
            setSelectedOrientation(displayOrientations[0]);
          }
        }
      }
    };
    t11 = [displayOrientations, selectedOrientation];
    $[34] = displayOrientations;
    $[35] = selectedOrientation;
    $[36] = t10;
    $[37] = t11;
  } else {
    t10 = $[36];
    t11 = $[37];
  }
  useEffect(t10, t11);
  let t12;
  bb2: {
    let t13;
    if ($[38] !== selectedGroup || $[39] !== selectedOrientation || $[40] !== selectedType || $[41] !== tree) {
      let t14;
      if ($[44] !== selectedGroup) {
        t14 = leaf_2 => leaf_2.handle === selectedGroup.handle;
        $[44] = selectedGroup;
        $[45] = t14;
      } else {
        t14 = $[45];
      }
      const group_1 = tree.find(t14);
      if (!group_1) {
        let t15;
        if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
          t15 = [];
          $[46] = t15;
        } else {
          t15 = $[46];
        }
        t12 = t15;
        break bb2;
      }
      let t15;
      if ($[47] !== selectedType) {
        t15 = leaf_3 => leaf_3.handle === selectedType.handle;
        $[47] = selectedType;
        $[48] = t15;
      } else {
        t15 = $[48];
      }
      const type_0 = group_1.children.find(t15);
      if (!type_0) {
        let t16;
        if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
          t16 = [];
          $[49] = t16;
        } else {
          t16 = $[49];
        }
        t12 = t16;
        break bb2;
      }
      let t16;
      if ($[50] !== selectedOrientation) {
        t16 = leaf_4 => leaf_4.handle === selectedOrientation.handle;
        $[50] = selectedOrientation;
        $[51] = t16;
      } else {
        t16 = $[51];
      }
      const orientation = type_0.children.find(t16);
      if (!orientation) {
        let t17;
        if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
          t17 = [];
          $[52] = t17;
        } else {
          t17 = $[52];
        }
        t12 = t17;
        break bb2;
      }
      t13 = orientation.children.map(makeSelection);
      $[38] = selectedGroup;
      $[39] = selectedOrientation;
      $[40] = selectedType;
      $[41] = tree;
      $[42] = t13;
      $[43] = t12;
    } else {
      t13 = $[42];
      t12 = $[43];
    }
    t12 = t13;
  }
  const displaySchemes = t12;
  let t13;
  let t14;
  if ($[53] !== displaySchemes || $[54] !== selectedScheme) {
    t13 = () => {
      if (displaySchemes.length > 0) {
        if (!selectedScheme.handle) {
          setSelectedScheme(displaySchemes[0]);
        } else {
          const valid_1 = displaySchemes.find(t15 => {
            const {
              id: id_1
            } = t15;
            return id_1 === selectedScheme.id;
          });
          if (!valid_1) {
            setSelectedScheme(displaySchemes[0]);
          }
        }
      }
    };
    t14 = [displaySchemes, selectedScheme];
    $[53] = displaySchemes;
    $[54] = selectedScheme;
    $[55] = t13;
    $[56] = t14;
  } else {
    t13 = $[55];
    t14 = $[56];
  }
  useEffect(t13, t14);
  let t15;
  if ($[57] !== displayOrientations || $[58] !== displaySchemes || $[59] !== displayTypes || $[60] !== selectedGroup || $[61] !== selectedOrientation || $[62] !== selectedScheme || $[63] !== selectedType) {
    t15 = {
      displayTypes,
      displayOrientations,
      displaySchemes,
      selectedGroup,
      setSelectedGroup,
      selectedType,
      setSelectedType,
      selectedOrientation,
      setSelectedOrientation,
      selectedScheme,
      setSelectedScheme
    };
    $[57] = displayOrientations;
    $[58] = displaySchemes;
    $[59] = displayTypes;
    $[60] = selectedGroup;
    $[61] = selectedOrientation;
    $[62] = selectedScheme;
    $[63] = selectedType;
    $[64] = t15;
  } else {
    t15 = $[64];
  }
  return t15;
};
export default useFilePermissions;